import cx from 'classnames';
import React, { useState } from 'react';

import s from './input.module.css';

import type { InputProps } from './index';

export interface InputCurrencyProps extends InputProps {
    currency?: string;
}

function is_numeric(str: string): boolean {
    return /^\d+$/.test(str);
}

export const InputCurrency = React.forwardRef<HTMLInputElement, InputCurrencyProps>(
    (
        {
            id,
            disabled,
            name,
            label,
            errorText,
            error = false,
            currency = 'EUR',
            className,
            wrapperClassName,
            ...props
        },
        ref
    ): JSX.Element => {
        if (currency.length > 3 || is_numeric(currency)) {
            throw new Error('Currency must respect ISO 4217 format (three letters)');
        }
        const [focus, setFocus] = useState(false);
        return (
            <div className={cx(s.container, wrapperClassName)}>
                {label && (
                    <label htmlFor={id || name} className={s.label}>
                        {label}
                    </label>
                )}
                <div
                    className={cx(s.inputCurrency, className, {
                        [s.disabled]: disabled,
                        [s.error]: error,
                        [s.focus]: focus,
                    })}
                    onFocus={() => setFocus(true)}
                    onBlur={() => setFocus(false)}
                >
                    <input
                        ref={ref}
                        id={id || name}
                        type="number"
                        name={name}
                        disabled={disabled}
                        {...props}
                    />
                    <p className={cx('body ink-light')}>{currency.toUpperCase()}</p>
                </div>
                {error && errorText && <p className={cx(s.errorText, 'annotation')}>{errorText}</p>}
            </div>
        );
    }
);

export default InputCurrency;
